import { ConsentFormDefinition } from '../types';
import { informedConsent } from './informed-consent';
import { consentSpecifiedDocument } from './consent-specified-document';
import { minorPatientTelehealth } from './minor-patient-telehealth';
import { hipaaPrivacyNotice } from './hipaa-privacy-notice';
import { therapyTelehealthConsent } from './therapy-telehealth-consent';

export const FORM_REGISTRY: Record<string, ConsentFormDefinition> = {
  'therapy-telehealth-consent': therapyTelehealthConsent,
  'informed-consent': informedConsent,
  'consent-specified-document': consentSpecifiedDocument,
  'minor-patient-telehealth': minorPatientTelehealth,
  'hipaa-privacy-notice': hipaaPrivacyNotice,
};

export const ALL_FORM_KEYS = Object.keys(FORM_REGISTRY);
